const axios = require('axios')
const isEmpty = require('lodash/isEmpty')

const apiUrl = require('../config/beauty-feed')

const client = {
  new: ({ localeCountry }) => {
    const api = axios.create({
      baseURL: apiUrl[vueSupport.env],
      headers: {
        'Accept-Language': localeCountry,
        'X-Platform': vueSupport.platform
      }
    })
    delete api.defaults.headers.common['X-Requested-With']
    return api
  }
}

const getAllArticles = (localeCountry, page = 1) => {
  const api = client.new({ localeCountry })
  return api.get(`articles`, {
    params: {
      include: 'content_types,article_filters',
      'page[number]': page,
      'page[size]': 9
    }
  })
}

const getAllArticlesByFilters = (localeCountry, options = {}) => {
  const api = client.new({ localeCountry })
  let params = {
    include: 'content_types',
    'page[number]': options.page || 1,
    'page[size]': options.perPage || 9
  }
  const { filter, include } = options

  if (!isEmpty(filter)) {
    const { articleFilters, contentTypes, slug, tags } = filter
    params = {
      ...params,
      'article-filters': articleFilters,
      'content-types': contentTypes,
      slug,
      tags
    }
  }

  if (include && include['article_contents']) {
    params = {
      ...params,
      include: `${params.include},article_contents`
    }
  }

  if (include && include['tags']) {
    params = {
      ...params,
      include: `${params.include},tags`
    }
  }

  return api.get(`articles`, {
    params
  })
}

const getArticleByFilters = (id, localeCountry, options = {}) => {
  const api = client.new({ localeCountry })

  let include = {}
  let nextArticleFilters = {}
  if (!isEmpty(options)) {
    if (options.filter) {
      const { tags, articleFilters, contentTypes } = options.filter
      nextArticleFilters = {
        'filter[next_article][tags]': tags,
        'filter[next_article][article-filters]': articleFilters,
        'filter[next_article][content-types]': contentTypes
      }
    }

    if (options.include) {
      include = { include: 'article_contents,content_types,article_filters,tags' }
    }
  }

  return api.get(`articles/${id}`, {
    params: {
      ...nextArticleFilters,
      ...include,
      'filter[next_article][platforms]': 'web'
    }
  })
}

const getArticleFilters = (localeCountry) => {
  const api = client.new({ localeCountry })
  return api.get(`article_filters`, {
    params: { show_all: true }
  })
}

const getContentTypes = (localeCountry) => {
  const api = client.new({ localeCountry })
  return api.get(`content_types`, {
    params: { show_all: true }
  })
}

const getTags = (localeCountry) => {
  const api = client.new({ localeCountry })
  return api.get(`tags`, {
    params: { show_all: true }
  })
}

const getBanners = (localeCountry) => {
  const api = client.new({ localeCountry })
  return api.get(`banners`)
}

export {
  getAllArticles,
  getAllArticlesByFilters,
  getArticleByFilters,
  getArticleFilters,
  getContentTypes,
  getTags,
  getBanners
}
